import LuckyBag2023 from "@/containers/LuckyBagNew2023"
import React from "react"

export default function NFTTOYBOX() {
  //======================================時間這裡改
  const dayS = +new Date("2023/03/30 11:00")
  const dayE = +new Date("2023/04/7 23:00")
  return <LuckyBag2023 dayS={dayS} dayE={dayE} />
}
